import Logging from '@fjell/logging';

const GCSLogger = Logging.getLogger('@fjell/lib-gcs');

export default GCSLogger;

